import { IMathJaxConfigOptions } from './math-jax-config-options.interface'

export const MATH_JAX_CONFIG = Object.freeze({
  /**
   * Base URL where to load MathJax from
   */
  URL: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/latest.js',

  /**
   * MathJax pre-configured options/query parameters on load
   *
   * http://docs.mathjax.org/en/latest/configuration.html#additional-query-string-options}
   */
  LOAD_PARAMS: Object.freeze({
    config: 'TeX-MML-AM_CHTML',
    delayStartupUntil: 'configured',
  }),

  /**
   * MathJax core, pre-processor, input-processor, output-processor, extension
   * and other options
   *
   * http://docs.mathjax.org/en/latest/options/index.html}
   * http://docs.mathjax.org/en/latest/api/hub.html#properties}
   */
  PROCESSOR_OPTIONS: Object.freeze({
    showProcessingMessages: false,
    skipStartupTypeset: true,
    showMathMenu: false,
    showMathMenuMSIE: false,
    tex2jax: {
      inlineMath: [['\\(', '\\)']],
      preview: 'none'
    },
    CommonHTML: {
      scale: 115,
      minScaleAdjust: 115,
      matchFontHeight: false
    }
  }) as IMathJaxConfigOptions,

  /**
   * Used to determine how long to wait/how often to check if MathJax has been loaded
   */
  LOADED_WAIT: {
    INITIAL_PERIOD_DURATION_MS: 100,
    TIMEOUT_AFTER_MS: 45000
  }
})



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/services/math-jax/math-jax-config.ts